/**
 * Calendar Event Create Page
 * Wrapper page for creating a new event
 */

import { useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import {
  Box,
  Container,
  Typography,
  Button,
  Alert,
} from '@mui/material'
import { ArrowBack } from '@mui/icons-material'
import CalendarEventEditor from '../components/editor/CalendarEventEditor'
import EventSubscriptionBanner, { useCanCreateEvent } from '../components/EventSubscriptionBanner'
import { useCalendarEventEditorStore } from '../stores/calendarEventEditorStore'

export function CalendarEventCreatePage() {
  const navigate = useNavigate()
  const { canCreate, isLoading } = useCanCreateEvent()
  const reset = useCalendarEventEditorStore((state) => state.reset)

  // Reset store on mount
  useEffect(() => {
    reset()
  }, [reset])

  // Redirect if user can't create events
  useEffect(() => {
    if (!isLoading && !canCreate) {
      // Don't navigate away, just show the subscription banner
    }
  }, [canCreate, isLoading, navigate])

  return (
    <Box>
      <Container maxWidth="md" sx={{ py: 2 }}>
        {/* Back button */}
        <Button
          component={Link}
          to="/events"
          startIcon={<ArrowBack />}
          color="inherit"
          sx={{ mb: 2 }}
        >
          Back to Events
        </Button>

        <Typography variant="h4" component="h1" gutterBottom>
          Create Event
        </Typography>

        {/* Show subscription banner */}
        {!canCreate && !isLoading && (
          <Alert severity="warning" sx={{ mb: 3 }}>
            You've reached your event creation limit for this month.
            <Button
              component={Link}
              to="/subscription"
              size="small"
              sx={{ ml: 2 }}
            >
              Upgrade
            </Button>
          </Alert>
        )}
      </Container>

      {/* Editor */}
      {canCreate ? (
        <CalendarEventEditor />
      ) : (
        <Container maxWidth="md">
          <EventSubscriptionBanner />
        </Container>
      )}
    </Box>
  )
}

export default CalendarEventCreatePage
